import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import superagent from 'superagent';
import feathers from '@feathersjs/client/dist/feathers';

import { fork, all } from 'redux-saga/effects';

import { club, clubs, searchClubs, advancedSearchClubs } from './club/reducers';
import * as clubSagas from './club/sagas';

import { user, getUser } from './user/reducers';
import * as userSagas from './user/sagas';

import { fixtures } from './fixture/reducers';
import * as fixtureSagas from './fixture/sagas';

const { rest, authentication } = feathers;

export const rootReducer = combineReducers({
  club,
  clubs,
  searchClubs,
  advancedSearchClubs,
  user,
  getUser,
  fixtures,
  router: routerReducer
});

export function* rootSaga() {
  yield all(
    [
      ...Object.values(userSagas),
      ...Object.values(clubSagas),
      ...Object.values(fixtureSagas)
    ].map(fork)
  );
}

const host = process.env.REACT_APP_API_URL;

export const app = feathers()
  .configure(rest(host).superagent(superagent))
  .configure(authentication({ storage: window.localStorage }));

export const usersService = app.service('users');
export const clubsService = app.service('clubs');
export const getInTouchService = app.service('getintouch');
export const fixturesService = app.service('fixtures');



// WEBPACK FOOTER //
// ./src/modules/index.js